import { GetterTree } from "vuex";
import { RootState } from "../types";
import { TemplatesInt } from "./types";
export const getters: GetterTree<TemplatesInt, RootState> = {};
